import React from "react";

import { useSignOut } from "src/features/auth/hooks/useSignOut";

export const SignOut: React.FunctionComponent = () => {
	const signOut = useSignOut();
	React.useEffect(() => {
		signOut();
	}, [signOut]);
	return null;
};
